import { IStyle, mergeStyles } from "@fluentui/react";
import React, { ReactNode, useEffect } from "react";
import { useMeasure } from "@uidotdev/usehooks";

interface PcpResizableProps {
    children: ReactNode,
    styles: IStyle,
    onResize: (width: number | null) => void,
}
export const PcpResizable = (props: PcpResizableProps): JSX.Element => {
    const {children, styles, onResize} = props;
    const [ref, { width, height }] = useMeasure();

    useEffect(() => onResize(width), [onResize, width]);

    return (
        <div ref={ref} className={mergeStyles(styles)}>
            {children}
        </div>
    )
}